import { render, staticRenderFns } from "./unmatched-client-view.vue?vue&type=template&id=08728d8a&scoped=true"
import script from "./unmatched-client-view.vue?vue&type=script&lang=js"
export * from "./unmatched-client-view.vue?vue&type=script&lang=js"
import style0 from "./unmatched-client-view.vue?vue&type=style&index=0&id=08728d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08728d8a",
  null
  
)

export default component.exports